import { PortugueseContractDataDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ContractFieldsProps } from 'modules/contracts/lib/types'

export interface PortugueseContractData {
  loading: boolean
  contractTypes: ContractFieldsProps[]
}

const useFetchPortugueseContractData = (
  country: string,
  notHidden?: boolean
): PortugueseContractData => {
  const { company } = useCurrentSession()
  const { loading, data } = useQuery(PortugueseContractDataDocument, {
    variables: {
      companyId: company.id,
      notHidden,
    },
    skip: country !== 'pt',
  })
  const templateData = data?.contracts.contractTemplatesConnection.nodes[0]
  const contractTypes = templateData?.portugueseContractType || []

  return {
    loading,
    contractTypes,
  }
}

export default useFetchPortugueseContractData
